/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {deleteOrder, getAllOrder} from '../api/order'
import {useParams} from 'react-router-dom'
import {IFilterParams, OrderListModel} from '../interface/Order'
import {toast} from 'react-toastify'
import Pagination from '../../../components/Pagination'
import ModalDelete from '../../../components/Modals/ModalDelete'
import {AutoComplete, Col, Row} from 'antd'
import {DatePicker} from 'antd'
import {Moment} from 'moment'
import {RangeValue} from 'rc-picker/lib/interface'
import {ListOrder as LOrder} from '../../../components/common/order/ListOrder'
import useMerchant from '../../../components/useMerchant'
import Spinner from '../../../components/Spinner'
import Search from '../../../components/Search'

const {RangePicker} = DatePicker

interface IPageParams {
  pageNo: string
}

const filterValues = {
  page: '1',
  filterBy: 'all',
  search: '',
  merchantId: '',
  date: '',
}

const ListOrder: FC = () => {
  const [orderList, setOrderList] = useState<OrderListModel>()
  const [deleteId, setDeleteId] = useState<string>('')
  const {pageNo} = useParams<IPageParams>()
  const [loading, setLoading] = useState<boolean>(true)
  const [merchants, setMerchants] = useMerchant()
  const [filterParams, setFilterParams] = useState<IFilterParams>(filterValues)

  function getOrder(filterParams: IFilterParams) {
    setLoading(true)
    getAllOrder(filterParams)
      .then((data) => {
        setLoading(false)
        setOrderList(data)
      })
      .catch((err) => {
        setLoading(false)
        toast.error('Error!')
      })
  }
  useEffect(() => {
    getOrder(filterParams)
  }, [filterParams])

  useEffect(() => {
    setFilterParams({...filterParams, page: pageNo})
  }, [pageNo])

  function handleDelete(event: React.ChangeEvent<any>, id: string) {
    event.preventDefault()
    deleteOrder(id).then((data) => {
      toast.success('Success!')
      getOrder(filterParams)
    })
  }

  const handleDatePickerChange = (date: RangeValue<Moment>, dateString: [string, string]) => {
    setFilterParams({...filterParams, date: dateString})
  }

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const {value, name} = event.target
    setFilterParams({...filterParams, [name]: value, page: '1'})
  }
  // const handlePageClick = (selectedItem: any) => {
  //   console.log(selectedItem)
  //   console.log(orderList)
  //   // const newOffset = (event.selected * itemsPerPage) % items.length
  //   // console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`)
  //   // setItemOffset(newOffset)
  // }

  return (
    <div className='d-flex flex-column flex-column-fluid' id='kt_content'>
      {/*begin::Post*/}
      <div className='post d-flex flex-column-fluid' id='kt_post'>
        {/*begin::Container*/}
        <div id='kt_content_container' className='container-xxl'>
          {/*begin::Card*/}
          <div className='card'>
            {/*begin::Card order*/}
            <div className='card-header border-0 pt-6'>
              {/*begin::Card title*/}
              <div className='card-title'>
                {/*begin::Search*/}

                <Row gutter={[16, 24]} className='mb-4'>
                  <Col className='gutter-row'>
                    <Search
                      name={filterParams.search!}
                      placeholder='Order ID'
                      handleSearch={handleFilter}
                    />
                  </Col>
                  <Col className='gutter-row'>
                    <AutoComplete
                      options={merchants}
                      style={{display: 'block'}}
                      filterOption={(inputValue, option) => {
                        return option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }}
                      onSelect={(value, options) => {
                        setFilterParams({...filterParams, page: '1', merchantId: options.id})
                      }}
                    >
                      <input
                        className='form-control form-control-solid w-250px me-2'
                        placeholder='Search Merchants'
                      />
                    </AutoComplete>
                  </Col>
                  <Col className='gutter-row'>
                    <RangePicker
                      className='form-control form-control-solid'
                      style={{display: 'inline-flex'}}
                      onChange={(date, dateString) => handleDatePickerChange(date, dateString)}
                      // value={[
                      //     moment(formik.values.holiday_mode_from),
                      //     moment(formik.values.holiday_mode_to),
                      //   ]
                      // }
                    />
                  </Col>
                  <Col className='gutter-row'>
                    <button
                      type='submit'
                      className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder me-2'
                      onClick={() => {
                        setFilterParams({
                          ...filterParams,
                          date: '',
                          merchantId: '',
                          filterBy: 'all',
                        })
                      }}
                    >
                      Reset
                    </button>
                  </Col>
                  <Col className='gutter-row'>
                    <select
                      className='form-select form-select-solid'
                      data-placeholder='Select option'
                      defaultValue='all'
                      value={filterParams.filterBy}
                      onChange={(event) => {
                        setFilterParams({...filterParams, page: '1', filterBy: event.target.value})
                      }}
                    >
                      <option value='all' disabled>
                        Filter Status
                      </option>
                      <option value='ACKNOWLEDGED'>Acknowledged</option>
                      <option value='PACKAGING'>PACKAGING</option>
                      <option value='SHIPPED'>Shipped</option>
                      <option value='DELIVERED'>Delivered</option>
                      <option value='CANCELED'>Canceled</option>
                      <option value='REJECTED'>Rejected</option>
                    </select>
                  </Col>
                </Row>

                {/*end::Search*/}
              </div>
              {/*begin::Card title*/}
              {/*begin::Card toolbar*/}
              <div className='card-toolbar'>
                {/*begin::Toolbar*/}
                <div className='d-flex justify-content-end' data-kt-order-table-toolbar='base'>
                  {/* justifyend */}
                </div>
                {/*end::Toolbar*/}
                {/*begin::Modal - Delete*/}
                <ModalDelete id={deleteId} handleDelete={handleDelete} />

                {/*end::Modal - delete*/}
              </div>
              {/*end::Card toolbar*/}
            </div>
            {/*end::Card order*/}
            {/*begin::Card body*/}
            <div className='card-body pt-0'>
              {/*begin::Table*/}
              <div
                id='kt_table_orders_wrapper'
                className='dataTables_wrapper dt-bootstrap4 no-footer'
              >
                <div className='table-responsive'>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <LOrder orderList={orderList} isAdmin={true} setDeleteId={setDeleteId} />
                  )}
                </div>
                <Pagination
                  name='order'
                  currentPage={filterParams.page}
                  prev_page={orderList?.prev_page}
                  next_page={orderList?.next_page}
                  total_number_of_page={orderList?.total_number_of_page}
                />
              </div>
              {/*end::Table*/}
            </div>
            {/*end::Card body*/}
          </div>
          {/*end::Card*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Post*/}
    </div>
  )
}

export default ListOrder
